<ziro-top-nav></ziro-top-nav>
<div class="ziro-add-user-page-content">
  <div class="container-fluid animate__animated animate__fadeIn">
    <div class="col-md-8 offset-md-2">
      @if (isLoading) {
        <ziro-loading-block></ziro-loading-block>
      }

      <div [hidden]="isLoading">
        <ziro-breadcrumbs></ziro-breadcrumbs>
        <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
          <ziro-select [fieldId]="'cucmServer'"></ziro-select>
          <ziro-text [fieldId]="'userName'"></ziro-text>
          <ziro-text [fieldId]="'firstName'"></ziro-text>
          <ziro-text [fieldId]="'lastName'"></ziro-text>
        </ziro-collapsible-section-card>
      </div>
    </div>
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
